import PropTypes from "prop-types"

const BodyPage = ({ children }) => {
  return (
    <section id="app-root" className="main-stacker">
      <div>
        <div>
          <ul>
            <li>
              <a href="/testing/amulets">Amulets</a>
            </li>
            <li>
              <a href="/testing/bracelets">Bracelets</a>
            </li>
          </ul>
        </div>
      </div>
      {children}
    </section>
  )
}

BodyPage.propTypes = {
  children: PropTypes.any,
}

export default BodyPage
